export const getExternalAccountsSchema = (state) =>
  state?.externalAccounts?.schema;
export const getExternalAccountSchema = (accountType) => (state) =>
  state?.externalAccounts?.schema?.subtypes?.find(
    ({ subtype }) => subtype === accountType,
  );
export const getExternalAccountsByType = (accountType) => (state) =>
  state?.externalAccounts?.accounts?.[accountType];
export const getExternalAccountById = (accountId) => (state) =>
  state?.externalAccounts?.account?.[accountId];
export const getExternalAccountListParams = (listKey) => (state) =>
  state?.lists?.[listKey] || {};
